import React from "react";
import Skeleton from "react-loading-skeleton";
import PaperCard from "../PaperCard";

const CardSkelton = () => {
  return (
    <div style={{ display: "flex" }}>
      {Array(4)
        .fill(0)
        .map((_, index) => (
          <Skeleton
            key={index}
            height={150}
            width={220}
            style={{
              marginBottom: "15px",
              flexWrap: "wrap",
              borderRadius: "10px",
              marginRight: "40px",
            }}
          />
        ))}
    </div>
  );
};

export default CardSkelton;
